import { render, staticRenderFns } from "./quotation_type_list.vue?vue&type=template&id=00d7ec40&scoped=true"
import script from "./quotation_type_list.vue?vue&type=script&lang=js"
export * from "./quotation_type_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d7ec40",
  null
  
)

export default component.exports